import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { Button, tokens, PageHeader } from '@hotjar/hotsauce';
import { useCurrentSite } from '@hotjar/site';
import { goToNewBillingPaymentTicketForm } from '@hotjar/webapp/help/actions';
import type { Site } from '@hotjar/site';
import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

const COMPARE_PLANS_ELEMENT_NAME = 'compare_plans_ctabutton';
const COMPARE_PLANS_URL = 'https://hotjar.com/pricing';

const Container = styled.div`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4} 0;
`;

export const PlansAndBillingHeader = (): JSX.Element => {
  const { t } = useTranslation('revenue');
  const { data: currentSite } = useCurrentSite();
  const { click: trackClick } = useTrack();
  const { i18n } = useTranslation();

  const onContactSupport = () => {
    goToNewBillingPaymentTicketForm(
      'Plans & Billing Contact',
      currentSite as Site,
      i18n?.resolvedLanguage ?? 'en',
    );
  };

  const onComparePlans = () => {
    trackClick(
      COMPARE_PLANS_ELEMENT_NAME,
      'Plans and Billing Page header',
      extractSiteGroupingProps(currentSite),
    );
    window.open(COMPARE_PLANS_URL, '_blank');
  };

  return (
    <Container>
      <PageHeader
        title={t('plans-and-billing-page.title')}
        actions={
          <>
            <Button kind="secondary" icon="chat" onClick={onContactSupport}>
              {t('plans-and-billing-page.contact')}
            </Button>
            <Button kind="secondary" icon="tag" onClick={onComparePlans}>
              {t('plans-and-billing-page.compare-plans')}
            </Button>
          </>
        }
      />
    </Container>
  );
};
